<template>
  <section class="login">
    <section class="container">
      <div class="login-main">
        <div class="title">eip登录</div>
        <div class="error" v-if="errorMsg">{{ errorMsg }}</div>
        <el-form ref="form" :model="form" :rules="rules" :hide-required-asterisk="true" label-width="0px">
          <ZFFormItem label="账号" prop="username">
            <el-input v-model.trim="form.username" placeholder="账号"></el-input>
          </ZFFormItem>
          <ZFFormItem label="密码" prop="password">
            <el-input v-model.trim="form.password" type="password" placeholder="密码"></el-input>
          </ZFFormItem>
          <el-form-item>
            <el-button class="btn" type="primary" @click="login">登 录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </section>
  </section>
</template>
<script>
import ZFFormItem from '@/components/ZFFormItem.vue'
import { authApi } from '@/api/serviceEip'
import { JSEncrypt } from 'jsencrypt'
import { mapMutations } from 'vuex'

export default {
  components: {
    ZFFormItem
  },
  data() {
    return {
      tenantCode: this.$route.params.tenant || 'platform',
      logo: '',
      loading: false,
      errorMsg: '',
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ validator: this.checkAccount, trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  created() {},
  methods: {
    ...mapMutations('sys', ['setToken']),
    login() {
      this.errorMsg = ''
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true
            const res = await authApi({
              username: this.form.username,
              password: this.encryptWithRsa(this.form.password)
            })
            const { token } = res
            this.setToken(token)
            await this.$router.replace({ path: '/eipManage/' })
          } catch (e) {
            console.error(e)
            this.errorMsg = e.message
          } finally {
            this.loading = false
          }
        } else {
          return false
        }
      })
    },
    // 账号校验
    checkAccount(rule, value, callback) {
      if (!value) {
        return callback(new Error('请输入账号'))
      }
      if (/^[a-zA-Z0-9_-]{2,20}$/.test(value)) {
        return callback()
      } else {
        return callback(new Error('账号格式不符合规范'))
      }
    },
    // rsa加密
    encryptWithRsa(str) {
      if (!str) {
        return ''
      }
      let encrypt = new JSEncrypt()
      let key = window.eipRSAPublicKey
      if (!key) {
        key =
          'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCMnhQ99yP-eEU2jXdQWc6j-wWbqNLqOLinEGBY11WJUCmzHiEycDXPc6-3YMOvrdAiHZcjkMCzU_eRnBLUqkcNw9nhQrCak-sTpEVlAV21LskD6KMf-6PsfttUvpXeCO5g3Hg48F_vbLKxb8s_lcvQgCpKBIpsUdYRcp_PgSg8BQIDAQAB'
      }
      encrypt.setPublicKey(key)
      return encrypt.encrypt(str)
    }
  }
}
</script>
<style lang="scss" scoped>
.login {
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url('~@/assets/img/login/bg.png');
  background-size: 100% 100%;
}
.container {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 626px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-main {
  width: 480px;
  .title {
    margin-bottom: 40px;
    color: #065ad8;
    font-size: 24px;
    text-align: center;
  }
  .btn {
    width: 100%;
  }
}
.error {
  margin-bottom: 20px;
  color: #f20e0e;
}
</style>
